var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"leftside-menu mt-0"},[_c('div',{staticClass:"text-center mt-3"},[_c('img',{attrs:{"src":_vm.JciLogo,"alt":"jci-logo","height":"54"}})]),_c('div',{staticClass:"h-100",attrs:{"id":"leftside-menu-container","data-simplebar":""}},[_c('menu-lists',{attrs:{"dialog":_vm.dialog},on:{"hideMenuDialog":_vm.hideMenuDialog}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }